import { SHIPPING_PATH } from 'modules/shipping/constants'
import getCurrentReduxSelector from 'modules/redux/selectors/get-current'

/**
 * Gets the selected rate.
 * @param  {State} state
 * @returns {string}
 */
function getSelectedMethodShippingUtil (state) {
  return getCurrentReduxSelector(
    SHIPPING_PATH.DATA, SHIPPING_PATH.SELECTED
  )(state)
}

export {
  getSelectedMethodShippingUtil
}
